// store/reducers/dashboardReducer.js
import {
  FETCH_DASHBOARD_REQUEST,
  FETCH_DASHBOARD_SUCCESS,
  FETCH_DASHBOARD_FAILURE,
  SET_DASHBOARD_PERIOD,
} from './dashboardAction';

const initialState = {
  loading: false,
  error: null,
  data: null,
  period: '30d',
  lastFetchedAt: null,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        period: (action.payload && action.payload.period) || state.period,
      };

    case FETCH_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload,
        lastFetchedAt: new Date().toISOString(),
      };

    case FETCH_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SET_DASHBOARD_PERIOD:
      return {
        ...state,
        period: action.payload,
      };

    default:
      return state;
  }
};

export default dashboardReducer;